import type { Character } from "./data";

export function CharacterArt({
  character,
  className = "",
  decorative = false,
}: {
  character: Character;
  className?: string;
  decorative?: boolean;
}) {
  return (
    <span
      className={`character-art character-${character.id} ${className}`}
      role={decorative ? undefined : "img"}
      aria-label={decorative ? undefined : `${character.name}角色造型`}
      aria-hidden={decorative || undefined}
    >
      <img
        className="art-image"
        src={`/assets/characters/${character.id}.png`}
        alt=""
        draggable={false}
      />
    </span>
  );
}
